module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./IndexView.jsx"));
	}, "PrinterList");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PrinterList!./src/pages/Printer/PrinterList/IndexView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=PrinterList!./src/pages/Printer/PrinterList/IndexView.jsx
// module chunks = 43